import { debounce } from 'radash'
import { useEffect, useLayoutEffect, useState } from 'react'

import { useRootElement } from '@root/shared/ui-kit'

export const useWidthThreshold = (width: number) => {
  const rootElement = useRootElement()

  const containerWidth = rootElement?.clientWidth ?? window.innerWidth

  const [overThreshold, setOverThreshold] = useState<boolean>(
    containerWidth > width,
  )

  useEffect(() => {
    setOverThreshold(containerWidth > width)
  }, [containerWidth, width])

  useLayoutEffect(() => {
    const handleResize = () => setOverThreshold(window.innerWidth > width)

    const debounced = debounce({ delay: 100 }, handleResize)

    window.addEventListener('resize', debounced, { passive: true })

    return () => window.removeEventListener('resize', debounced)
  }, [width])

  return overThreshold
}
